import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ServiceFormatter } from "../../helpers/service-formatter";
import { MorFileProcessedDataRequest } from "../../models/mor-file-processed-data-request";
import { MorFileErrorResult } from "../../models/mor-file-error-result";

@Injectable({
    providedIn: 'root'
})
export class MorDataService {
    private endpoint = ServiceFormatter.endpoint;

    constructor(private http: HttpClient) {}

    getMORFileDetails(id: number) {
      const params: HttpParams = new HttpParams()
      .set("id", id);
      return this.http.get<any>(
        this.endpoint + "MORData/get-file-details", 
        ServiceFormatter.getHttpOptions(params)
      );
    }

    getProcessedRecordDataByMorQueueID(request: MorFileProcessedDataRequest) {
      return this.http.post<any>(
        this.endpoint + "MORData/get-processed-records-by-file",
        request,
        ServiceFormatter.getHttpOptions()
      );
    }

    getErrorRecordDataByMorQueueID(request: MorFileProcessedDataRequest) {
      return this.http.post<any>(
        this.endpoint + "MORData/get-error-records-by-file",
        request,
        ServiceFormatter.getHttpOptions()
      );
    }
}
